import React from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  background-color: ${props => props.accent === 'true' ? 'var(--primary-dark)' : 'var(--card-bg)'};
  color: ${props => props.accent === 'true' ? 'var(--text-primary)' : 'inherit'};
  border-radius: var(--border-radius);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: ${props => props.padding || '1.5rem'};
  margin-bottom: ${props => props.marginBottom || '1.5rem'};
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  transition: box-shadow 0.3s ease, transform 0.2s ease;
  
  &:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
  }
  
  h2, h3, h4 {
    color: ${props => props.accent === 'true' ? 'var(--text-primary)' : 'var(--text-primary)'};
    margin-bottom: 0.75rem;
    font-weight: 600;
  }
`;

function Card({ children, title, accent, padding, marginBottom, ...props }) {
  return (
    <CardContainer
      accent={accent ? "true" : "false"}
      padding={padding}
      marginBottom={marginBottom}
      {...props}
    >
      {title && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1rem"
          }}
        >
          <h3>{title}</h3>
          {props.action} 
        </div>
      )}

      {children}
    </CardContainer>
  );
}


export default Card;